export const NoticeMode = {
  ADD: 'add',
  UPDATE: 'update',
};

export default {
  NoticeMode,
};
